const SECTIONS = [
  {
    title: "Responsable du traitement",
    body: [
      "Présence Home Services — Carole Bourbasquet, Entrepreneur individuel, U Centru, Route de Bastia, 20137 Porto-Vecchio, Corse-du-Sud, France — E-mail : caropv2a@gmail.com.",
    ],
  },
  {
    title: "Données collectées",
    body: [
      "Via les formulaires de contact et de demande de réservation : nom, prénom, numéro de téléphone, adresse e-mail, ainsi que les informations relatives à votre demande (dates de séjour, nombre de personnes, bien souhaité, type de bien et localisation pour les demandes de gestion).",
      "Via l'espace propriétaire : identifiants de connexion (adresse e-mail et mot de passe chiffré).",
    ],
  },
  {
    title: "Finalités du traitement",
    body: [
      "Les données collectées servent exclusivement à : traiter vos demandes de location et de gestion, organiser votre séjour ou la gestion de votre bien, et vous recontacter dans ce cadre.",
      "Vos données ne font l'objet d'aucune prospection commerciale et ne sont ni vendues ni cédées à des tiers.",
    ],
  },
  {
    title: "Base légale",
    body: [
      "Le traitement repose sur l'exécution de mesures précontractuelles ou contractuelles (réponse à votre demande) et sur l'intérêt légitime de Présence Home Services à gérer sa relation avec ses clients.",
    ],
  },
  {
    title: "Durée de conservation",
    body: [
      "Les données issues des formulaires sont conservées au maximum trois ans à compter du dernier échange, sauf obligation légale contraire.",
    ],
  },
  {
    title: "Vos droits",
    body: [
      "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition concernant vos données.",
      "Pour exercer ces droits, écrivez à : caropv2a@gmail.com. Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).",
    ],
  },
  {
    title: "Cookies",
    body: [
      "Le site n'utilise aucun cookie publicitaire ou de suivi. Seuls des cookies techniques strictement nécessaires au fonctionnement de l'espace propriétaire (cookies d'authentification) sont déposés lors de la connexion à cet espace.",
    ],
  },
  {
    title: "Sécurité",
    body: [
      "Présence Home Services met en œuvre des mesures techniques raisonnables pour protéger vos données (connexion chiffrée, mots de passe hachés, accès restreints).",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-page" className="min-h-screen px-5 pb-24 pt-32 sm:px-8 sm:pt-40">
      <div className="mx-auto max-w-3xl">
        <p className="eyebrow">Presence Home Services</p>
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-maquis-deep">Politique de confidentialité</h1>
        <p className="mt-6 text-sm sm:text-base leading-relaxed text-maquis-olive">
          La présente politique décrit la manière dont Présence Home Services collecte, utilise et protège vos données personnelles lorsque vous utilisez ce site.
        </p>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title} data-testid={`privacy-section-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <h2 className="font-serif text-2xl text-maquis-deep">{s.title}</h2>
              <div className="mt-3 space-y-2 text-sm sm:text-base leading-relaxed text-maquis-olive">
                {s.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
